import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppContext } from "../context/AppContext";

export default function RequireAuth({ children }) {
  const { token, user, loadingApp } = useContext(AppContext);
  const location = useLocation();

  // While app is rehydrating, don't redirect yet (prevents flicker / redirect loops)
  if (loadingApp) return null;

  // Treat either token or user as "authenticated" (adapt if your app requires both)
  const isAuthed = Boolean(token) || Boolean(user);
  if (!isAuthed) {
    return <Navigate to="/auths/auth-login" replace state={{ from: location }} />;
  }

  return children;
}
